import type { MutationHookOptions } from "@apollo/client/react/types/types";

import { apolloClient } from "@/app/utils/newApolloClient";

export function refetch(): MutationHookOptions {
  return {
    awaitRefetchQueries: true,
    onCompleted: () => {
      apolloClient.value?.resetStore();
    },
  };
}
